<template>
 <div class="list-item-schedule" @click="selectScheduleItem(value)">
    <v-subheader class="header-18">{{ value.name }}</v-subheader>
    <v-list-tile avatar >
      <!-- <v-list-tile-avatar>
        <img :src="image">
      </v-list-tile-avatar> -->
      <v-list-tile-content>
        <v-list-tile-title >
          <template v-if="!value.priceVariations">
            <span class="item-price">{{ value.price | currency }}</span>
          </template>
          <template v-else>
            <v-tooltip bottom>
              <span slot="activator" class="item-price">{{ value.priceTable[0].price | currency }}</span><span slot="activator" v-if="value.priceTable.length > 1"> e mais {{ value.priceTable.length - 1 }}...</span>
              <span>
                <ul>
                  <li v-for="(price, i) in value.priceTable" :key="i">{{ price.description }} - {{ price.price | currency }}</li>
                </ul>
              </span>
            </v-tooltip>            
          </template>
        </v-list-tile-title>
        <v-list-tile-sub-title>
          <template v-if="!value.priceVariations">
            {{value.description}}
          </template>
          <template v-else>
            <v-tooltip bottom>
              <span slot="activator">{{value.description}}</span>
              <span>
                <ul>
                  <li v-for="(price, i) in value.priceTable" :key="i">{{ price.description }} - {{ price.price | currency }}</li>
                </ul>
              </span>
            </v-tooltip> 
          </template>
          
        </v-list-tile-sub-title>            
      </v-list-tile-content>
      <v-list-tile-action>                  
        <template v-if="value.priceVariations">
          <v-tooltip bottom>                                
            <v-icon
              slot="activator"
              v-if="!selected"
              color="grey lighten-1"
              >
              crop_square
             </v-icon>
             <v-icon
              slot="activator"
              v-else
              color="green darken-2"
              >
              done
             </v-icon>
             <span>
              <ul>
                <li v-for="(price, i) in value.priceTable" :key="i">{{ price.description }} - {{ price.price | currency }}</li>
              </ul>
            </span>
          </v-tooltip>  
        </template>
        <template v-else>
          <v-icon
            slot="activator"
            v-if="!selected"
            color="grey lighten-1"
            >
            crop_square
          </v-icon>
          <v-icon
            slot="activator"
            v-else
            color="green darken-2"
            >
            done
          </v-icon>
        </template>     
      </v-list-tile-action>   
    </v-list-tile>
    <v-divider></v-divider>  
 </div>
</template>

<script>
export default {
  name: 'item-box',
  props: ['value'],
  methods: {
    selectScheduleItem (value) {
      this.$store.dispatch('addOrRemoveItemSchedule', value)
    }
  },
  computed: {
    image () {
      return this.value.images === null || this.value.images.length === 0 ? '' : this.value.images[0]
    },
    selected () {
      if (this.$store.getters.selectedItens.length === 0) {
        return false
      } else {
        const item = this.$store.getters.selectedItens.filter((elem) => {
          return elem.id === this.value.id
        })
        return item.length > 0
      }
    }
  },
  filters: {
    currency (value) {
      let newValue = 0
      if (typeof value !== 'number') {
        newValue = parseFloat(value.replace('.', '').replace(',', '.'))
      } else if (typeof value === 'number') {
        newValue = value
      } else {
        return ''
      }
      return newValue.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
    }
  }
}
</script>

<style>
.header-18{
  font-size: 18px;
}
.list-item-schedule:hover{
  background: rgba(0,0,0,0.12);
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// index.vue?153ce0fd